import * as React from 'react';
import { ECounterPosition } from '@cian/frontend-fullscreen-carousel-component';
import { ConstructionProgressHeaderContainer } from '../ConstructionProgressHeader';

export const CONSTRUCTION_PROGRESS_FULLSCREEN_SETTINGS = [
  {
    minWidth: -Infinity,
    maxWidth: 641,
    options: {
      defaultControls: [],
      hideThumbnails: true,
      counterPosition: ECounterPosition.HEADER,
      contentOptions: {
        headerContent: <ConstructionProgressHeaderContainer />,
      },
    },
  },
  {
    minWidth: 641,
    maxWidth: Infinity,
    options: {
      hideThumbnails: false,
      contentOptions: {
        headerContent: <ConstructionProgressHeaderContainer />,
      },
    },
  },
];
